import { Routes } from '@angular/router';
import { AuthGuard, LoginGuard } from '../guards';

export const routes: Routes = [
  { path: '', redirectTo: 'user', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [LoginGuard],
    loadChildren: () =>
      import('../modules/auth/routes').then((m) => m.authRoutes),
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../modules/user/routes').then((m) => m.userRoutes),
  },
  {
    path: 'patients',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../modules/patient/routes').then((m) => m.patientRoutes),
  },
  {
    path: 'icu',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../modules/icu/routes').then((m) => m.icuRoutes),
  },
  {
    path: 'doctors',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../modules/doctor/routes').then((m) => m.doctorRoutes),
  },
  {
    path: 'nurses',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../modules/nurse/routes').then((m) => m.nurseRoutes),
  },
  {
    path: 'shift-managers',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../modules/shift-manager/routes').then((m) => m.shiftManagerRoutes),
  }
];



